import { css } from '@emotion/css';

export const styles = {
  bulletInTableCell: css({
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  }),

  dartFormContainer: css({
    maxWidth: '1440px',
  }),

  radiodropdownParent: css({
    marginTop: '10px',
  }),

  title: css({
    marginTop: '10px',
    marginBottom: '5px',
  }),

  contactSummary: css({
    marginTop: '20px',
  }),

  buttonsContainer: css({
    textAlign: 'end',
    width: '100%',
    marginTop: '50px',
  }),

  saveButton: css({
    margin: '0 10px',
  }),

  emailCheckboxContainer: css({
    textAlign: 'end',
    paddingLeft: '10px',
    marginTop: '10px',
    '& > *': {
      display: 'unset !important',
    },
  }),

  dropdownItemContainer: css({
    '& > div': {
      marginTop: '20px',
      minWidth: '250px !important',
      marginRight: '20px',
      '&:first-child': {
        display: 'none',
      },
    },
  }),
};
